/**
 * Request a Quote - modal controller
 * ---------------------------------------------------------------------------
 * Owns the popup only. Deciding WHICH variant is quote-only, and blocking the
 * purchase controls for it, lives in quote-mode.js; this file just receives the
 * resolved details, fills the contact form and shows the popup.
 */
window.RequestQuoteModal = (function () {
  'use strict';

  var MODAL_SELECTOR = '#RequestQuoteModal';
  var QUICKVIEW_SELECTOR = '#jsQuickview';

  function normalizeUrl(url) {
    if (!url) return window.location.href;
    try {
      return new URL(url, window.location.origin).href;
    } catch (error) {
      return url;
    }
  }

  function getModal() {
    return document.querySelector(MODAL_SELECTOR);
  }

  function setValue(selector, value) {
    var element = document.querySelector(selector);
    if (element) element.value = value == null ? '' : value;
  }

  function setText(selector, value) {
    var element = document.querySelector(selector);
    if (element) element.textContent = value == null ? '' : value;
  }

  function buildBody(details) {
    return [
      'Title: Request a Quote',
      'Product name: ' + details.productTitle,
      'Product URL: ' + details.productUrl,
      'Selected variants: ' + details.variantTitle,
      'Variant ID: ' + details.variantId,
      'SKU: ' + details.variantSku
    ].join('\n');
  }

  function populate(rawDetails) {
    var details = {
      productTitle: (rawDetails && rawDetails.productTitle) || '',
      productUrl: normalizeUrl(rawDetails && rawDetails.productUrl),
      variantTitle: (rawDetails && rawDetails.variantTitle) || 'Default',
      variantId: (rawDetails && rawDetails.variantId) || '',
      variantSku: (rawDetails && rawDetails.variantSku) || ''
    };

    setText('[data-request-quote-product-title]', details.productTitle);
    setText('[data-request-quote-variant-title]', details.variantTitle);

    var variantLine = document.querySelector('.request-quote-modal__variant');
    if (variantLine) variantLine.hidden = !details.variantTitle;
    setValue('#RequestQuoteProductName', details.productTitle);
    setValue('#RequestQuoteProductUrl', details.productUrl);
    setValue('#RequestQuoteSelectedVariant', details.variantTitle);
    setValue('#RequestQuoteVariantId', details.variantId);
    setValue('#RequestQuoteSku', details.variantSku);
    setValue('#RequestQuoteBody', buildBody(details));

    return details;
  }

  function showModal() {
    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.modal) {
      window.jQuery(MODAL_SELECTOR).modal('show');
      return;
    }

    var modal = getModal();
    if (!modal) return;
    modal.classList.add('show');
    modal.style.display = 'block';
    modal.removeAttribute('aria-hidden');
    modal.setAttribute('aria-modal', 'true');
  }

  /** Quick View and the quote popup are both Bootstrap modals - never stack. */
  function showAfterQuickview() {
    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.modal) {
      var $quickview = window.jQuery(QUICKVIEW_SELECTOR);
      if ($quickview.length && $quickview.hasClass('show')) {
        $quickview.one('hidden.bs.modal.requestQuote', showModal);
        $quickview.modal('hide');
        return;
      }
    }
    showModal();
  }

  function open(details) {
    populate(details);
    showAfterQuickview();
  }

  document.addEventListener(
    'submit',
    function (event) {
      if (!event.target.matches || !event.target.matches('#RequestQuoteForm')) return;

      var form = event.target;
      var read = function (id) {
        var field = form.querySelector(id);
        return field ? field.value : '';
      };

      var body = form.querySelector('#RequestQuoteBody');
      if (body) {
        body.value = [
          'Title: Request a Quote',
          'Product name: ' + read('#RequestQuoteProductName'),
          'Product URL: ' + read('#RequestQuoteProductUrl'),
          'Selected variants: ' + read('#RequestQuoteSelectedVariant'),
          'Variant ID: ' + read('#RequestQuoteVariantId'),
          'SKU: ' + read('#RequestQuoteSku'),
          'First name: ' + read('#RequestQuoteFirstName'),
          'Last name: ' + read('#RequestQuoteLastName'),
          'Email: ' + read('#RequestQuoteEmail'),
          'Phone number: ' + read('#RequestQuotePhone'),
          'Address: ' + read('#RequestQuoteAddress')
        ].join('\n');
      }

      var button = form.querySelector('[type="submit"]');
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Sending...';
      }
    },
    true
  );

  function reopenAfterPost() {
    var modal = getModal();
    if (!modal) return;

    var variantLine = modal.querySelector('.request-quote-modal__variant');
    if (variantLine) {
      var value = variantLine.querySelector('[data-request-quote-variant-title]');
      variantLine.hidden = !(value && value.textContent.trim());
    }

    var status = modal.getAttribute('data-form-status');
    if (status === 'success' || status === 'error') showModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reopenAfterPost);
  } else {
    reopenAfterPost();
  }

  return {
    open: open,
    populate: populate,
    show: showModal
  };
})();
